// src/pages/LoginPage.jsx

import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './LoginPage.css'; // Ensure this CSS file exists for styling

const LoginPage = () => {
  const { login, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // State to manage form submission status
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Ref to prevent multiple navigations
  const hasNavigated = useRef(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Login form submitted:', { email, password }); // Debug log
    setIsSubmitting(true);
    try {
      await login({ email, password });
      // Navigation and toast are handled in AuthContext's useEffect
    } catch (error) {
      console.error('Login failed:', error.response?.data?.message || error.message);
      // Error handling is already managed in AuthContext
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && !hasNavigated.current) {
      navigate('/dashboard');
      // Removed duplicate toast here
      hasNavigated.current = true;
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleSubmit} data-testid="login-form">
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            placeholder="Enter your email address"
            data-testid="email-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="Enter your password"
            data-testid="password-input"
          />
        </div>
        <button type="submit" className="login-button" disabled={isSubmitting} data-testid="submit-button">
          {isSubmitting ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <p>
        Don't have an account? <Link to="/register">Register here.</Link>
      </p>
    </div>
  );
};

export default LoginPage;
